import { AbpHttpInterceptor, RefreshTokenService, AbpHttpConfigurationService } from 'abp-ng2-module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import * as ApiServiceProxies from './service-proxies';
import { ZeroRefreshTokenService } from '@account/auth/zero-refresh-token.service';
import { ZeroTemplateHttpConfigurationService } from './zero-template-http-configuration.service';
import { ZeroTemplateHttpInterceptor } from './zero-template-http-interceptor';

@NgModule({
    providers: [
        ApiServiceProxies.CustomerPaymentsServiceProxy,
        ApiServiceProxies.VendorPaymentsServiceProxy,
        ApiServiceProxies.PurchaseTransactionServiceProxy,
        ApiServiceProxies.PurchaseOrdersServiceProxy,
        ApiServiceProxies.PurchaseInvoiceServiceProxy,
        ApiServiceProxies.PurchaseReturnServiceProxy,
        ApiServiceProxies.PurchaseReportServiceProxy,
        ApiServiceProxies.AddStockServiceProxy,
        ApiServiceProxies.StockAdjustmentServiceProxy,
        ApiServiceProxies.StockTransferServiceProxy,
        ApiServiceProxies.ProductionServiceProxy,
        ApiServiceProxies.StockTakeServiceProxy,
        ApiServiceProxies.SalesOrderServiceProxy,
        ApiServiceProxies.SalesInvoiceServiceProxy,
        ApiServiceProxies.SalesReturnServiceProxy,
        ApiServiceProxies.InventoryReportServiceProxy,
        ApiServiceProxies.SalesTransactionServiceProxy,
        ApiServiceProxies.ProductsServiceProxy,
        ApiServiceProxies.TaxesServiceProxy,
        ApiServiceProxies.CustomersServiceProxy,
        ApiServiceProxies.SalespersonsServiceProxy,
        ApiServiceProxies.VendorsServiceProxy,
        ApiServiceProxies.PriceGroupsServiceProxy,
        ApiServiceProxies.RetailPlanServiceProxy,
        ApiServiceProxies.SubCategoriesServiceProxy,
        ApiServiceProxies.UnitsServiceProxy,
        ApiServiceProxies.BrandsServiceProxy,
        ApiServiceProxies.DepartmentsServiceProxy,
        ApiServiceProxies.StockAdjustmentTypeServiceProxy,
        ApiServiceProxies.CategoriesServiceProxy,
        ApiServiceProxies.CurrenciesServiceProxy,
        ApiServiceProxies.PaymentTypesServiceProxy,
        ApiServiceProxies.ChartOfAccountsServiceProxy,
        ApiServiceProxies.AccountSubGroupsServiceProxy,
        ApiServiceProxies.AccountJournalServiceProxy,
        ApiServiceProxies.AccountJournalReportServiceProxy,
        ApiServiceProxies.AccountGroupsServiceProxy,
        ApiServiceProxies.PaymentTermsServiceProxy,
        ApiServiceProxies.LocationsServiceProxy,
        ApiServiceProxies.CompaniesServiceProxy,
        ApiServiceProxies.AuditLogServiceProxy,
        ApiServiceProxies.CachingServiceProxy,
        ApiServiceProxies.ChatServiceProxy,
        ApiServiceProxies.CommonLookupServiceProxy,
        ApiServiceProxies.EditionServiceProxy,
        ApiServiceProxies.FriendshipServiceProxy,
        ApiServiceProxies.HostSettingsServiceProxy,
        ApiServiceProxies.InstallServiceProxy,
        ApiServiceProxies.LanguageServiceProxy,
        ApiServiceProxies.NotificationServiceProxy,
        ApiServiceProxies.OrganizationUnitServiceProxy,
        ApiServiceProxies.PurchaseNotesServiceProxy,
        ApiServiceProxies.SalesNotesServiceProxy,
        ApiServiceProxies.PermissionServiceProxy,
        ApiServiceProxies.ProfileServiceProxy,
        ApiServiceProxies.RoleServiceProxy,
        ApiServiceProxies.SessionServiceProxy,
        ApiServiceProxies.TenantServiceProxy,
        ApiServiceProxies.TenantDashboardServiceProxy,
        ApiServiceProxies.TenantSettingsServiceProxy,
        ApiServiceProxies.TimingServiceProxy,
        ApiServiceProxies.UserServiceProxy,
        ApiServiceProxies.UserLinkServiceProxy,
        ApiServiceProxies.UserLoginServiceProxy,
        ApiServiceProxies.WebLogServiceProxy,
        ApiServiceProxies.AccountServiceProxy,
        ApiServiceProxies.TokenAuthServiceProxy,
        ApiServiceProxies.TenantRegistrationServiceProxy,
        ApiServiceProxies.HostDashboardServiceProxy,
        ApiServiceProxies.PaymentServiceProxy,
        ApiServiceProxies.DemoUiComponentsServiceProxy,
        ApiServiceProxies.InvoiceServiceProxy,
        ApiServiceProxies.SubscriptionServiceProxy,
        ApiServiceProxies.InstallServiceProxy,
        ApiServiceProxies.UiCustomizationSettingsServiceProxy,
        ApiServiceProxies.PayPalPaymentServiceProxy,
        ApiServiceProxies.StripePaymentServiceProxy,
        ApiServiceProxies.DashboardCustomizationServiceProxy,
        ApiServiceProxies.WebhookEventServiceProxy,
        ApiServiceProxies.WebhookSubscriptionServiceProxy,
        ApiServiceProxies.WebhookSendAttemptServiceProxy,
        ApiServiceProxies.UserDelegationServiceProxy,
        ApiServiceProxies.DynamicPropertyServiceProxy,
        ApiServiceProxies.DynamicEntityPropertyDefinitionServiceProxy,
        ApiServiceProxies.DynamicEntityPropertyServiceProxy,
        ApiServiceProxies.DynamicPropertyValueServiceProxy,
        ApiServiceProxies.DynamicEntityPropertyValueServiceProxy,
        ApiServiceProxies.TwitterServiceProxy,
        ApiServiceProxies.EntityChangeServiceProxy,
        { provide: RefreshTokenService, useClass: ZeroRefreshTokenService },
        { provide: AbpHttpConfigurationService, useClass: ZeroTemplateHttpConfigurationService },
        { provide: HTTP_INTERCEPTORS, useClass: ZeroTemplateHttpInterceptor, multi: true },
    ],
})
export class ServiceProxyModule { }
